export default __webpack_public_path__ + "static/media/promission-profiles.13b6a258.png";